import { formatName } from '../lib/format';
export const capitaliseNameWords = formatName

const personNameFields = new Set([
  'firstName', 'lastName', 'workerFirstName', 'workerLastName', 'workerName',
  'userName', 'sentByName', 'emergencyFirstName', 'emergencyLastName',
]);

// Only known person-name fields are formatted; identifiers, emails and prose stay intact.
export function formatPersonNames(value, parentKey = '') {
  if (Array.isArray(value)) return value.map(item => formatPersonNames(item, parentKey));
  if (!value || Object.getPrototypeOf(value) !== Object.prototype) return value;
  return Object.fromEntries(Object.entries(value).map(([key, item]) => [
    key,
    typeof item === 'string' && (personNameFields.has(key) || (key === 'name' && ['worker', 'workers'].includes(parentKey)))
      ? capitaliseNameWords(item)
      : formatPersonNames(item, key),
  ]));
}
